// extracted by mini-css-extract-plugin
export default {"search_content":"document-list-view_search_content__yyhGk","btn":"document-list-view_btn__NklYd","field_label":"document-list-view_field_label__+lN85"};